const initialState = {
  showMenu: false,
  showAllCode: true,
  backFromPages: false,
};

export default initialState;
